import React, { Component, Fragment, createContext } from 'react'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../css/style.css'
import Navigation from './Navigation'
import {
  phoneSzczecin,
  phonePila,
  FBLinkSzczecin,
  FBLinkPila
} from '../helpers/cityHelper';
import LazyLoad from 'react-lazyload'

import coFinancedEUFundsImg from '../media/images/fundusze_logo.png'

export const NavContext = createContext('');

const Image = props => {
  const { src, alt } = props
  return (
    <LazyLoad height={100} throttle={200}>
      <img
        className="album-img"
        src={src}
        alt={alt}
      />
    </LazyLoad>
  )
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { imgSrc, selectedCity, setCity } = this.props
    const phoneHref =
      selectedCity === 'szczecin' ? `tel:${phoneSzczecin}` : `tel:${phonePila}`
    const contactPhone = `${isMobile ? phoneHref : '/kontakt'}`
    return (
      <Fragment>
        <div className="top-bar">
          <header className="container">
            <div className="content-half-box col-xs-12 col-sm-6 col-md-6">
              <ul>
                <li>
                  <a
                    href={
                      selectedCity === 'szczecin' ? FBLinkSzczecin : FBLinkPila
                    }
                    target="_"
                  >
                    Facebook
                  </a>
                </li>
              </ul>
            </div>
            <div className="content-half-box col-xs-12 col-sm-6 col-md-6">
              {selectedCity === 'szczecin' && (
                <a
                  title="Kontakt - prywatny zlobek Rudolf Szczecin"
                  href="mailto:zlobek.rudolf@gmail.com"
                  className="content-half-box col-xs-12 col-sm-5 col-md-5"
                >
                  zlobek.rudolf@gmail.com
                </a>
              )}
              {selectedCity === 'pila' && (
                <a
                  title="Kontakt - prywatny zlobek Rudolf Piła"
                  href="mailto:zlobek.rudolf.pila@gmail.com"
                  className="content-half-box col-xs-12 col-sm-5 col-md-5"
                >
                  zlobek.rudolf.pila@gmail.com
                </a>
              )}

              {selectedCity === 'szczecin' && (
                <a
                  title="Kontakt - prywatny zlobek Rudolf"
                  href={contactPhone}
                  className="content-half-box col-xs-12 col-sm-5 col-md-5"
                >
                  {phoneSzczecin}
                </a>
              )}
              {selectedCity === 'pila' && (
                <a
                  title="Kontakt - prywatny zlobek Rudolf"
                  href={contactPhone}
                  className="content-half-box col-xs-12 col-sm-5 col-md-5"
                >
                  {phonePila}
                </a>
              )}
            </div>
          </header>
        </div>
        <NavContext.Provider value={setCity}>
          <Navigation imgSrc={imgSrc} selectedCity={selectedCity} setCity={setCity}/>
        </NavContext.Provider>
        
        {selectedCity === 'pila' && (
          <div className="co-financed-wrapper">
            <a href="/pila/maluch-plus">
              <Image src={coFinancedEUFundsImg} alt="Dofinansowanie maluch plus" />
            </a>
          </div>

              )}
        
      </Fragment>
    )
  }
}

Header.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  selectedCity: PropTypes.string.isRequired,
  setCity: PropTypes.func.isRequired,
}

export default Header
